import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Contract, IContract} from '../../shared/model/contract.model';
import {ContractService} from './contract.service';
import {HttpResponse} from '@angular/common/http';

// import { JhiEventManager } from 'ng-jhipster';


@Component({
  selector: 'app-contract-delete-dialog',
  templateUrl: './contract-delete-dialog.component.html'
})
export class ContractDeleteDialogComponent implements OnInit {
  contract: IContract = new Contract();
  @Input() contractEdit;

  constructor(protected contractService: ContractService,
              public activeModal: NgbActiveModal,
              // protected eventManager: JhiEventManager
  ) {
  }

  ngOnInit() {
    // alert(' in id===' + this.contractEdit);
    // alert(' in init ==' + this.contractEdit);
    if (this.contractEdit) {

      this.contractService.find(this.contractEdit).subscribe(
        (res: HttpResponse<IContract>) => {
          this.contract = res.body;
          // alert(this.contract);
        },
        // (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
  }

  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmDelete(id: number) {
    this.contractService.delete(id).subscribe(response => {
      // this.eventManager.broadcast({
      //     name: 'contractListModification',
      //     content: 'Deleted an contract'
      // });
      this.activeModal.dismiss(true);
    });
  }
}
